import { FrameEditInvoiceSnapshot, FrameListInvoiceSnapshot } from '@Modules/InvoiceSnapshots';
import { RouteObject } from 'react-router';
import { setupModuleRouting } from './setupModuleRouting';

export function setupInvoiceSnapshotRouting(): RouteObject {
    return setupModuleRouting({
        resourcePath: 'invoices',
        editFrame: <FrameEditInvoiceSnapshot />,
        listFrame: <FrameListInvoiceSnapshot />,
    });
}
